<div class="text-center my-2">
  <a [routerLink]="['/batch/groups/index',server_user_id]" class="me-2 btn btn-primary"><i class="fa fa-list"></i>Cancel</a>
  </div>
  <div class="alert alert-info text-center">
    Create Subscription Group
  </div>

<form [formGroup] = "myForm" (ngSubmit)="on_submit()" class="form" enctype="multipart/form-data" *ngIf="!loading">

  <div class="form-group row" [ngClass]="{error:f.name.errors && f.name.touched}">
      <label for="subjectId" class='control-label col-sm-3' >Group Name</label>
          <div class="input-group controls col-sm-8">
            <input type="text" id="name" formControlName="name" class="form-control">
          </div>
          <div *ngIf="f.name.errors && f.name.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
            <ul>
                <li>Name Required.</li>
            </ul>
        </div>
    </div>

    <div class="form-group row" [ngClass]="{error:f.description.errors && f.name.touched}">
      <label for="subjectId" class='control-label col-sm-3' >Description</label>
          <div class="input-group controls col-sm-8">
            <input type="text" id="description" formControlName="description" class="form-control">
          </div>
          <div *ngIf="f.description.errors && f.description.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
            <ul>
                <li>Description Required.</li>
            </ul>
        </div>
    </div>


  <div class="text-center">
    <button [disabled]="isSaving" type="submit" class="btn btn-primary mt-3">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1"></span>
      Submit
  </button>
  </div>

</form>
